/**
 * API Configuration
 * Shared constants for backend API endpoints across all games
 */

/**
 * Meta Auth API Base URL
 * Used for authentication, game saves, and player preferences
 */
export const META_AUTH_API_URL = 'https://hwd9npm4s4.execute-api.us-east-2.amazonaws.com';

/**
 * Landing Page URL
 * Used as fallback when no specific game is specified
 */
export const LANDING_PAGE_URL = 'https://mentalmintgames.com';

/**
 * Landing Page ID
 * Used to identify the main landing page (not a specific game)
 */
export const LANDING_PAGE_ID = 'landing';

/**
 * API Endpoints
 */
export const API_ENDPOINTS = {
  SEND_MAGIC_LINK: `${META_AUTH_API_URL}/send-magic-link`,
  VERIFY_MAGIC_LINK: `${META_AUTH_API_URL}/verify-magic-link`,
  SAVE_GAME_STATE: `${META_AUTH_API_URL}/save-game-state`,
  LOAD_GAME_STATE: `${META_AUTH_API_URL}/load-game-state`,
  GET_PREFERENCES: `${META_AUTH_API_URL}/get-preferences`,
  UPDATE_PREFERENCES: `${META_AUTH_API_URL}/update-preferences`,
} as const;
